import type { License } from "@/types/api";
import { ReactComponent as Check } from "@/assets/icons/Check.svg";
import React from "react";
import { cn, isAfter, isBefore, isWithin } from "@/utils/utils";
import { Timer } from "lucide-react";

export interface LicenseRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
    variant: "timed" | "perpetual";      
  }

export const LicenseRow = React.forwardRef<HTMLDivElement, License>((license, ref) => {
  const color = (() => {
    if (isBefore(license.expirationDate)) {
      return "text-musio-red";
    } else if (isWithin(license.expirationDate, 30)) {
      return "text-musio-orange";
    } else if (isAfter(license.expirationDate)) {
      return "text-musio-green";
    }
  })(); 

  return (
    <div className="flex flex-col text-xs w-full px-3 py-1 sm:flex-row justify-between gap-2" ref={ref} style={{ backgroundColor:"rgba(126, 120, 165, 0.4)" }}>
      <div className="flex flex-col sm:flex-row justify-between w-full gap-2 l sm:w-1/2">
        <p className="font-bold underline sm:no-underline">{license.productName}</p>
        <div className="flex flex-row justify-between font-light w-full sm:gap-10 sm:w-fit">
          <p className="text-musio-light-lilac">{license.subject}</p>
          <p className={cn("", color)}>{license.expirationDate}</p>
        </div>
      </div>
      {license.expired === true ? (<ExpiredCross/>) : license.activated === true && (<ActiveCheck/>)}
    </div>
  );
});

const ActiveCheck = () => {
  return (
    <div className="flex flex-row items-center space-x-1 text-musio-green">
      <Check className="h-[12px] w-[12px]"/>
      <p 
        className="font-semibold text-xs"
      >
        Active
      </p>

    </div>
  );
};

const ExpiredCross = () => {
  return (
    <div className="flex flex-row items-center space-x-1 text-musio-red">
      <Timer className="h-[12px] w-[12px]"/>
      <p 
        className="font-semibold text-xs"
      >
        Expired 
      </p>

    </div>
  );
};
